export default "/shipway.8e75adcf-4d7ef9.png";